import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import LeadSection from "@/components/sections/LeadSection";
import EditorialMarquee from "@/components/Marquee";
import { Reveal } from "@/components/Reveal";
import { Check } from "@phosphor-icons/react";
import { IMAGES } from "@/data/content";

const OFFER = [
  "Portfolio-wide service agreements",
  "RTU change-outs & rooftop equipment",
  "Priority scheduling & reliable communication",
  "Documented diagnostics and maintenance history",
  "Clean workmanship in occupied buildings",
  "Clear scope and transparent pricing",
];

export default function PropertyManagers() {
  return (
    <>
      <Seo title="Property Managers | Genuine Forge — Commercial HVAC Chicago" description="Dependable HVAC service and installation support for property managers across Chicago — RTU change-outs, priority scheduling, and documented maintenance." />
      <PageHero eyebrow="Property Managers" title="A mechanical partner for your portfolio." lede="Reliable HVAC service and installation support built for property managers — priority scheduling, clean workmanship, and documentation you can file." image={IMAGES.rtu} />

      <section className="border-t border-white/10 py-20 md:py-28">
        <div className="mx-auto grid max-w-[1440px] gap-12 px-6 md:px-12 lg:grid-cols-[1fr_1fr]">
          <Reveal>
            <h2 className="max-w-xl font-display text-3xl font-extrabold leading-tight tracking-tight md:text-4xl">Built for buildings that can't afford downtime.</h2>
            <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-slatex-300">
              From no-heat emergencies to planned rooftop change-outs, we keep your tenants comfortable and your records clean. One accountable partner across the portfolio.
            </p>
            <div className="mt-8 overflow-hidden border border-white/10">
              <img src={IMAGES.mechanicalRoom} alt="Commercial mechanical room" className="aspect-video w-full object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="grid gap-px border border-white/10 bg-white/10">
              {OFFER.map((o, i) => (
                <div key={o} className="flex items-start gap-3 bg-ink p-6">
                  <span className="font-mono text-xs text-brand-cyan">{String(i + 1).padStart(2, "0")}</span>
                  <Check size={14} weight="bold" className="mt-0.5 shrink-0 text-brand-cyan" />
                  <span className="font-body text-sm text-white">{o}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <EditorialMarquee text="Priority Scheduling · Clean Handoff · Documented Work · Portfolio Support ·" speed={22} />
      <LeadSection commercial sourcePage="property-managers" />
    </>
  );
}
